import PropTypes from 'prop-types'

export const CentreType = PropTypes.shape({
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  status: PropTypes.oneOf(['Open', 'Closed']).isRequired,
})

const NavigationMenuItemType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
})

export const NavigationMenuGroupType = PropTypes.shape({
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(NavigationMenuItemType).isRequired,
})

export const NavigationMenuType = PropTypes.arrayOf(NavigationMenuGroupType)
